import React from 'react'
import { Container, Element, Heading, Image, Section } from 'react-bulma-components'
import Layout from '../components/layout/layout'
import { Translate } from '../utils/translations'
import { OptimizedImage } from '../components/optimized-image'
//@ts-expect-error
import logo from '../assets/images/logo.png'
import { setTranslations } from 'react-i18nify'
import locales from '../../../locales/basketball-hoop-b900-form'
import RepairPresentation from '../components/repair/repair-presentation'
import { campaign } from '../campaigns'

/**
 * Repair Kit Request Page
 * Standalone page for requesting repair kits for basketball hoops
 */
const RepairKitPage: React.FC = () => {
  setTranslations(locales)

  /**
   * Handles form submission for repair kit requests
   * @param values - The form data submitted by the user
   */
  const handleSubmit = (values: any) => {
    console.log('Repair kit request submitted:', values)
    // TODO: Implement actual API call to submit repair kit request
    // For now, just log the data
  }

  return (
    <Layout>
      <Image src={logo} style={{ maxWidth: 320, margin: 'auto' }} />
      <Section pb={2} mb={5}>
        <Container>
          <Heading size={2} textAlign="center" mb={6}>
            <Translate value="repair.title" />
          </Heading>

          <Element style={{ maxWidth: 600, margin: 'auto' }} mb={5}>
            <OptimizedImage
              imageName="tarmak_b900_box_nba"
              alt="Tarmak B900 Basketball Hoop NBA Edition"
              priority={true}
              loading="eager"
            />
          </Element>

          <Element style={{ maxWidth: 1024, margin: 'auto' }}>
            <RepairPresentation repair={campaign.repair} />
          </Element>
        </Container>
      </Section>
    </Layout>
  )
}

export default RepairKitPage
